import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from './app-config.service';
import { Incident } from '../models/incident';

@Injectable({
  providedIn: 'root'
})
export class IncidentService {
  constructor(
    private http: HttpClient,
    private appConfigSvc: AppConfigService
  ) {}

  load() {
    return this.http.get<Incident[]>(
      this.appConfigSvc.getConfig().apiRoot + '/Incident'
    );
  }
}
